import { render, staticRenderFns } from "./u-dialog-color-bg-rounded.vue?vue&type=template&id=7db54f68&scoped=true&"
import script from "./u-dialog-color-bg-rounded.vue?vue&type=script&lang=js&"
export * from "./u-dialog-color-bg-rounded.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7db54f68",
  null
  
)

export default component.exports